import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ClassHelper } from '../../helpers/translateDefaultClass';
import { queries } from 'src/config/queries';
export function useGetListClassDrippingStatus(moduleId) {
    const { t } = useTranslation();
    return useQuery({
        ...queries.modules.listClassDrippingStatus(moduleId),
        placeholderData: [],
        select: (classes) => ClassHelper.translateDefaultClass(classes, t)
    });
}
